import clsx from 'clsx'
import styles from './deployments.module.css'

export type DeploymentsView = 'list' | 'customer'

/** List | By customer. */
export function ViewToggle({ value, onChange }: { value: DeploymentsView; onChange: (view: DeploymentsView) => void }) {
  return (
    <div className={styles.segmented} role="radiogroup" aria-label="View">
      {(
        [
          ['list', 'List'],
          ['customer', 'By customer'],
        ] as const
      ).map(([view, label]) => (
        <button
          key={view}
          type="button"
          role="radio"
          aria-checked={value === view}
          data-testid={`view-${view}`}
          className={clsx(styles.segment, value === view && styles.segmentActive)}
          onClick={() => onChange(view)}
        >
          {label}
        </button>
      ))}
    </div>
  )
}
